import NewsContent from './NewsContent'

export default NewsContent
